import React from 'react'
import BooksList, { useBooks } from './BooksList'
import Spinner from 'components/Spinner';
import ErrorIndicator from 'components/ErrorIndicator';

type Props = {
    onTabChange: (tab: string) => void
}

export default function YourBooks({ }: Props) {

    const { data: books = [], isLoading, error } = useBooks('me');

    if (isLoading) {
        return <Spinner className='mx-auto mt-2' />
    }

    if (error) {
        return <ErrorIndicator error={error} />
    }

    return (
        <div>
            <h3 className='is-size-3 mb-5 between'>
                <strong>
                    Your Sources
                </strong>
            </h3>
            <BooksList books={books} />
        </div>
    )
}